<template>
  <div class="hook">
    <div class="pull-left play">
      <i class="fa fa-fw fa-play" @click="handlePlay" v-if="!isPlaying"></i>
      <i class="fa fa-fw fa-stop" @click="handleStop" v-if="isPlaying"></i>
    </div>
    <div class="detail">
      <div class="title">{{ hook.title }}</div>
      <div class="artist">{{ hook.artist }}</div>
    </div>
    <div class="duration pull-right" v-if="!isPlaying">{{ duration }}</div>
    <div class="duration time pull-right" v-else>{{ currentTime }}</div>
  </div>
</template>

<script>
export default {
  name: 'HookMedia',
  props: {
    hook: {
      type: Object,
      required: true,
    },
  },
  data: () => ({
    audio: null,
    isPlaying: false,
    audioDuration: null,
    audioCurrentTime: null,
  }),
  mounted() {
    this.audio = new Audio(this.hook.fileUrl);
    this.audio.addEventListener('play', this.handleOnPlay);
    this.audio.addEventListener('pause', this.handleOnStop);
    this.audio.addEventListener('loadedmetadata', this.handleOnLoadedMetadata);
    this.audio.addEventListener('timeupdate', this.handleOnTimeUpdate);
  },
  computed: {
    duration() {
      if (!this.audio || !this.audioDuration) {
        return '00:00';
      }

      return this.calculateDuration(this.audioDuration);
    },

    currentTime() {
      if (!this.audio || !this.audioCurrentTime) {
        return '00:00';
      }

      return this.calculateDuration(this.audioCurrentTime);
    },
  },
  methods: {
    calculateDuration(durationSecs) {
      const duration = Math.trunc(durationSecs);
      const minutes = Math.floor(duration / 60);
      const seconds = duration % 60;

      const padded = num => num.toString().padStart(2, '0');

      return `${padded(minutes)}:${padded(seconds)}`;
    },

    handlePlay() {
      this.audio.play();
    },

    handleStop() {
      this.audio.pause();
      this.audio.currentTime = 0;
    },

    handleOnPlay() {
      this.isPlaying = true;
    },
    handleOnStop() {
      this.isPlaying = false;
    },
    handleOnLoadedMetadata() {
      this.audioDuration = this.audio.duration;
    },
    handleOnTimeUpdate() {
      this.audioCurrentTime = this.audio.currentTime;
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../../../../assets/style/_variables_live.scss';
.detail {
  display: inline-block;
  margin-left: 1em;
}

.title {
  font-weight: bold;
}

.duration {
  font-size: 0.9em;
  color: darken($colony-light-gray, 25%);

  &.time {
    color: $colony-dark-gray;
  }
}

.play {
  font-size: 2em;
  color: darken($colony-light-gray, 15%);
  cursor: pointer;
}

.play:hover {
  color: darken($colony-light-gray, 25%);
}
</style>



// WEBPACK FOOTER //
// HookMedia.vue?311037b7